module.exports = __webpack_public_path__ + "static/media/hugo-boss.f1546cd5.jpg";